// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2grZ9","colBig":"styles_colBig__23rkU","colSmall":"styles_colSmall__35cCO","shopifyNameWrapper":"styles_shopifyNameWrapper__1VT1I"};